<template>
  <b-container class="bv-example-row" id="menus">
    <b-col><h1>Menus</h1></b-col>
    <b-row>
      <b-form inline>
        <b-input type="text" v-model="name" placeholder="メニュー名" />
        <b-input type="text" v-model="description" placeholder="説明" />
        <b-input type="text" v-model="price" placeholder="価格" />
        <b-input type="text" v-model="photo" placeholder="image url" />
        <b-button v-on:click="createMenu">Create Menu</b-button>
      </b-form>
    </b-row>
    <b-row> <hr/></b-row>
    <b-row>
      <div>
      <b-card-group deck>
        <b-card v-for="item in menus" :key="item.id"
          :title="item.name"
          :img-src="item.photo"
          img-top
          img-height="300px"
          style="max-width: 20rem">
            <b-card-text>{{ item.description }}</b-card-text>
            <b-card-text><h3><b-badge variant="danger">￥{{ item.price }}</b-badge></h3></b-card-text>
        </b-card>
      </b-card-group>
      </div>
    </b-row>
  </b-container>
</template>

<script>
import { API } from "aws-amplify";
import { createMenu } from "../graphql/mutations";
import { listMenus } from "../graphql/queries";

export default {
  name: "Menus",
  async created() {
    this.getMenus();
  },
  data() {
    return {
      name: "",
      description: "",
      price: 0,
      photo: "",
      menus: [],
    };
  },
  methods: {
    async createMenu() {
      console.log("CreateMenu clicked");
      const { name, description, price, photo } = this;
      if (!name || !description || !photo || !price) return;
      try {
        const menu = {
          name: name,
          description: description,
          price: price,
          photo: photo,
        };
        this.menus = [...this.menus, menu];
        console.log(this.menus);
        await API.graphql({
          query: createMenu,
          variables: { input: menu },
        });
      } catch (error) {
        console.log("error: ", error);
      }
      this.name = "";
      this.description = "";
      this.price = 0;
      this.photo = "";
    },
    async getMenus() {
      const menus = await API.graphql({
        query: listMenus,
      });
      console.log(menus.data);
      this.menus = menus.data.listMenus.items;
    },
  },
};
</script>